import React, { useEffect } from 'react'
import moment from 'moment'

// the "join room" button and "active now" badge will be active this many
// minutes before the scheduled start time
const START_EARLY_MINUTES = 0

/**
@private
@returns the RoomMeeting that is active at the given time (with an x minute buffer
at the start of the schedule)
*/
const isLive = ({ roomMeeting, currentTime }) =>
  currentTime >=
    moment(roomMeeting.startsAt).subtract(START_EARLY_MINUTES, 'minutes') &&
  currentTime <= moment(roomMeeting.endsAt)

const isPending = ({ roomMeeting, currentTime }) =>
  currentTime <= moment(roomMeeting.startsAt)

const withEffects = WrappedComponent => {
  return props => {
    const {
      roomMeeting, // via withQuery
      setCurrentTime, // via withState
      currentTime, // via withState
      setLiveNow, // from withState
      setPendingNow // from withState
    } = props

    // every second, reset the current time and check to see if the room has any
    // schedules active now
    useEffect(() => {
      const timer = setTimeout(() => {
        const liveNow = isLive({
          roomMeeting,
          currentTime
        })
        const pendingNow = isPending({
          roomMeeting,
          currentTime
        })
        setLiveNow(liveNow)
        setPendingNow(pendingNow)
        setCurrentTime(moment())
      }, 1000)

      // clean up when component unmounts
      return () => clearTimeout(timer)
    }, [currentTime])

    return <WrappedComponent {...props} />
  }
}

export default withEffects
